// src/routes/AdminRoutes.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import ResponsiveDrawer from "../components/sidebar";
import RequirePermission from "./RequirePermission";
import Dashboard from "../screens/admin/dashboard";
import Projects from "../screens/admin/projects";
import Groups from "../screens/admin/groups";
import Users from "../screens/admin/users";
import Roles from "../screens/admin/roles";
import ViewTimeSheet from "../screens/admin/viewTimeSheet/container/ViewTimeSheet";
import MyTimeSheet from "../screens/user/time/container/Timesheet";
// import ViewTimeSheet from "../screens/admin/users/viewTimeSheet";

import TimeReport from "../screens/admin/timeReport/TimeReport";
import WeeklyTimeReport from "../screens/admin/weeklyTimeReport/WeeklyTimeReport";
import ViewSingleTimeSheet from "../screens/admin/weeklyTimeReport/ViewSingleTimeSheet";
import Clients from "../screens/admin/clients";
import AddClient from "../screens/admin/clients/add";
import ClientDetails from "../screens/admin/clients/details";
import AddProject from "../screens/admin/projects/add";
import Invoices from "../screens/admin/invoices";
import AddInvoice from "../screens/admin/invoices/add";
import InvoiceSummary from "../screens/admin/invoices/summary";
import Expenses from "../screens/expenses";
import Profile from "../screens/profile";
import AddExpense from "../screens/expenses/add";
import ExpenseReport from "../screens/expenses/report";

// Each screen names the permission it needs, so a role created with a narrow
// set of permissions lands in the admin shell with only the screens it may
// use. The server guards the data regardless; this is what stops a typed URL
// rendering a screen whose every request would come back 403.
//
// "My Timesheet" is the same screen the user shell uses for the caller's own
// week — an admin-portal role still needs somewhere to log its own hours.
//
// The dashboard, the profile and the expense screens carry no guard: they are
// the caller's own, and the API narrows them to the caller automatically.
function AdminsRoutes() {
  return (
    <ResponsiveDrawer>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route
          path="/time/add"
          element={
            <RequirePermission permission="timesheets.create">
              <MyTimeSheet />
            </RequirePermission>
          }
        />

        <Route
          path="/projects"
          element={
            <RequirePermission permission="projects.view">
              <Projects />
            </RequirePermission>
          }
        />
        <Route
          path="/projects/:projectId/edit"
          element={
            <RequirePermission permission="projects.edit">
              <AddProject />
            </RequirePermission>
          }
        />
        <Route
          path="/projects/add"
          element={
            <RequirePermission permission="projects.create">
              <AddProject />
            </RequirePermission>
          }
        />

        <Route
          path="/groups"
          element={
            <RequirePermission permission="groups.view">
              <Groups />
            </RequirePermission>
          }
        />
        <Route
          path="/users"
          element={
            <RequirePermission permission="users.view">
              <Users />
            </RequirePermission>
          }
        />
        <Route
          path="/roles"
          element={
            <RequirePermission permission="roles.manage">
              <Roles />
            </RequirePermission>
          }
        />

        <Route
          path="/clients"
          element={
            <RequirePermission permission="clients.view">
              <Clients />
            </RequirePermission>
          }
        />
        <Route
          path="/clients/:clientId"
          element={
            <RequirePermission permission="clients.view">
              <ClientDetails />
            </RequirePermission>
          }
        />
        <Route
          path="/clients/add"
          element={
            <RequirePermission permission="clients.create">
              <AddClient />
            </RequirePermission>
          }
        />

        <Route
          path="/invoices"
          element={
            <RequirePermission permission="invoices.view">
              <Invoices />
            </RequirePermission>
          }
        />
        <Route
          path="/invoices/summary"
          element={
            <RequirePermission
              permission={["invoices.view", "projects.view"]}
              requireAll
            >
              <InvoiceSummary />
            </RequirePermission>
          }
        />
        <Route
          path="/invoices/add"
          element={
            <RequirePermission permission="invoices.create">
              <AddInvoice />
            </RequirePermission>
          }
        />
        <Route
          path="/invoices/:invoiceId/edit"
          element={
            <RequirePermission permission="invoices.edit">
              <AddInvoice />
            </RequirePermission>
          }
        />

        <Route path="/profile" element={<Profile />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route
          path="/expenses/report"
          element={
            <RequirePermission permission="reports.expense">
              <ExpenseReport />
            </RequirePermission>
          }
        />
        <Route path="/expenses/add" element={<AddExpense />} />
        <Route path="/expenses/:expenseId/edit" element={<AddExpense />} />

        <Route
          path="/view-time-sheet/:userId"
          element={
            <RequirePermission permission="timesheets.view_all">
              <ViewTimeSheet />
            </RequirePermission>
          }
        />
        <Route
          path="/time-report"
          element={
            <RequirePermission permission="reports.time">
              <TimeReport />
            </RequirePermission>
          }
        />
        <Route
          path="/weekly-time-report"
          element={
            <RequirePermission permission="timesheets.view_all">
              <WeeklyTimeReport />
            </RequirePermission>
          }
        />
        <Route
          path="/weekly-time-sheet/:userId"
          element={
            <RequirePermission permission="timesheets.view_all">
              <ViewSingleTimeSheet />
            </RequirePermission>
          }
        />
      </Routes>
    </ResponsiveDrawer>
  );
}

export default AdminsRoutes;
